/*
    Contains event listeners and logic for filters
*/
var path = window.location.pathname;
path = path.replace(/\/$/, '');
var pageName = path.substring(path.lastIndexOf('/') + 1);

var filterpanelblock = {};
filterpanelblock.filters = (function ($) {
  var dropDown = '.dropdown-menu',
    dropDownButton = '.filterlist .dropdown-toggle',
    freeTextSearch = '#filter-freetext-input',
    allButton = '#filter-all--filter-tag',
    filterForm = '#filterForm',
    mobileCloseButton = '.mobile-header .close',
    parentCheckbox = '.parent',
    childCheckbox = '.child',
    checkedButtonId = '',
    $resultWrapper,
    filterCookie = 'FilterCookie_' + pageName,
    sortDropdownLista = '.sortering-dropdown--lista',
    sortDropdownKnapp = '.sortering-dropdown .dropdown-toggle';

  function init() {
    // Don't try to init if we are on the wrong page
    if (!$('.HanteraTipsSida, .HittaTipsSida').length) {
      return;
    }

    $resultWrapper = $('#list-result, #hanteraTipsContainer');
    initListeners();
    $('.filter-options__options').empty = clearCategoryFilter;
    var params = new URLSearchParams(window.location.search);

    //Om id finns bland params så kommer vi inte ladda filter från Cookie, pga Resursbanken
    if (Cookies.get(filterCookie) && !params.has('id')) {
      getFilterFromCookie(Cookies.get(filterCookie));
    }

    setSortingButtonWidth();
  }

  function initListeners() {
    $(document).on('click', dropDown, stopOutClick);
    $(document).on('click', dropDownButton, moveFilterButton);
    $(document).on('click', allButton, clearCategoryFilter);
    $(document).on('click', makeFilterOutsideClick);
    $(document).on('click', '.filter-button', toggleMobileMenu);
    $(document).on('click', '.back-button', backToFilter);
    $(document).on('click', '.submit-button', handleSubmitButtonClick);
    $(document).on('click', mobileCloseButton, removeMobileFilter);

    $(document).on('change', '#filterForm :input', checkIfChangeInForm);
    $(document).on('change', parentCheckbox, checkChildren);
    $(document).on('change', childCheckbox, checkParent);
    $(document).on('click', '.pagenumber', pagningUrlNumber);
    $(document).on('keypress', '#filterForm input[type="checkbox"]', checkWithKeypressed);
    $(document).on('click', '.sortering-dropdown--alt', sorting);
  }

  function checkWithKeypressed(event) {
    event.preventDefault();
    var queryStr = '';
    if (event.which === 13) {
      this.checked = !this.checked;
      $(this).trigger('change');
      $(dropDown + ' input:checked').each(function (i, item) {
        queryStr += (i == 0 ? '?' : '&') + $(item).attr('name') + '=';
        queryStr += $(item).val();
      });
      if ($(freeTextSearch).length !== 0 && $(freeTextSearch).val() !== '') {
        queryStr += (queryStr === '' ? '?' : '&') + 'fsq=' + $(freeTextSearch).val();
      }

      submitAjax(event, queryStr, '#' + checkedButtonId);
    }
  }

  function pagningUrlNumber(e) {
    var queryStr = '';
    queryStr += '?page=' + $(e.currentTarget).attr('data-pagenumber');
    $(dropDown + ' input:checked').each(function (i, item) {
      queryStr += '&' + $(item).attr('name') + '=';
      queryStr += $(item).val();
    });
    if ($(freeTextSearch).length !== 0 && $(freeTextSearch).val() !== '') {
      queryStr += (queryStr === '' ? '?' : '&') + 'fsq=' + $(freeTextSearch).val();
    }
    var focusAnchor = $('.ProgramListPage, .HittaTipsSida').length ? 'post-heading' : 'form0';
    submitAjax(e, queryStr, focusAnchor);
  }

  function checkChildren() {
    $(this).parent().parent().find(childCheckbox).prop('checked', $(this).prop('checked'));
  }

  function checkParent() {
    var parentCheckboxDiv = $(this).parent().parent().parent().parent();
    var parentCheckbox = parentCheckboxDiv.find('.parent');
    var checkedSubOptions = parentCheckboxDiv.find('.child:checked');
    var subOptions = parentCheckboxDiv.find('.child');

    parentCheckbox.prop('indeterminate', checkedSubOptions.length && checkedSubOptions.length != subOptions.length);
    parentCheckbox.prop('checked', checkedSubOptions.length == subOptions.length);
  }

  function submitAjax(e, queryString, changeFocus, sort) {
    var usp = new URLSearchParams(window.location.search);

    if (!sort) {
      if (usp.has('sort')) {
        if (queryString.includes('status') || queryString.includes('page')) {
          queryString += '&sort=' + usp.get('sort');
        } else {
          queryString += '?sort=' + usp.get('sort');
        }
      }
    }

    if (queryString == '') {
      queryString = '?';
    }

    e.preventDefault();
    var inOneHour = 1 / 24;
    Cookies.set(filterCookie, queryString, { expires: inOneHour });
    history.pushState(null, null, queryString);
    $.get(queryString, replaceResult).done(function () {
      // När resultat har laddats nollställ status för formulär
      $(filterForm).data('changed', false);
      // Uppdatera gömt element för sökresultat som skärmläsare ska uppfatta
      $('#sr-result').text($('#post-heading').text());
      $('body').css('position', '');
      if (changeFocus === 'post-heading' || changeFocus === 'form0') {
        document.getElementById(changeFocus).scrollIntoView();
        $('table tbody tr td a:first').focus();
      } else {
        $(changeFocus).focus();
      }

      // Återställ knapphantering
      accordionKnappResursbanken();

      setSortingButtonWidth();
    });
  }

  function getFilterFromCookie(queryString) {
    var sm = $('.statusmeddelande');
    var smClone;
    if (sm.length) {
      smClone = sm.clone();
    }

    if (!queryString.startsWith('?')) {
      queryString = '?' + queryString;
    }

    history.pushState(null, null, queryString);
    $.get(queryString, replaceResult).done(function () {
      // Statusmeddelande ska ligga kvar efter att session har nollställts och filtrerat resultat hämtas från cookie
      $('#hanteraTipsContainer').prepend(smClone);

      // Återställ knapphantering
      accordionKnappResursbanken();

      setSortingButtonWidth();
    });
  }

  function handleSubmitButtonClick(e) {
    var queryStr = '';

    var $inputChecked = $(dropDown + ' input:checked');
    if ($inputChecked.length > 0) {
      $inputChecked.each(function (i, item) {
        queryStr += (i == 0 ? '?' : '&') + $(item).attr('name') + '=' + $(item).val();
      });
    }

    if ($(freeTextSearch).length !== 0 && $(freeTextSearch).val() !== '') {
      queryStr += (queryStr === '' ? '?' : '&') + 'fsq=' + $(freeTextSearch).val();
    }

    submitAjax(e, queryStr, '#' + checkedButtonId);
  }

  function handleSubmitOutsideClick(e) {
    var queryStr = '';
    var $inputChecked = $('input:checked', e.currentTarget);
    if ($inputChecked.length > 0) {
      $inputChecked.each(function (i, item) {
        queryStr += (i == 0 ? '?' : '&') + $(item).attr('name') + '=' + $(item).val();
      });
    }
    if ($(freeTextSearch).length !== 0 && $(freeTextSearch).val() !== '') {
      queryStr += (queryStr === '' ? '?' : '&') + 'fsq=' + $(freeTextSearch).val();
    }

    submitAjax(e, queryStr, '#' + checkedButtonId);
  }

  function replaceResult(response) {
    $resultWrapper.html(response);
  }

  function removeMobileFilter() {
    $('.mobile-container').hide();
    $('body').css('position', '');
  }

  function toggleMobileMenu(e) {
    $('.mobile-container').toggle();
    $('body').css('position', 'fixed');
    e.preventDefault();
    return false;
  }

  function backToFilter() {
    $('.dropdown-toggle').removeClass('open');
  }

  function checkIfChangeInForm() {
    $(filterForm).data('changed', true);
    // Hämtar id från knappen för filtret
    checkedButtonId = $(this).closest('.dropdown.filter-options__options').children('.btn.btn-default.dropdown-toggle').attr('id');
  }

  function clearCategoryFilter(e) {
    var queryString = '';
    $('.container-inner input[type=checkbox]').prop('checked', false);
    submitAjax(e, queryString, '#filter-all--filter-tag');
  }

  function makeFilterOutsideClick(e) {
    if ($(filterForm).data('changed')) {
      // submit the form
      handleSubmitOutsideClick(e);
    }
  }

  function stopOutClick(e) {
    e.stopPropagation();
  }

  function moveFilterButton() {
    if ($(this).siblings(dropDown).is(':visible')) {
      $('.container-submit').appendTo($(this).siblings(dropDown));
      if ($(this).siblings(dropDown).find('.child').length > 0) {
        $('.dropdown-menu .container-inner ul').each(function () {
          var parentCheckboxList = $(this);
          var parentCheckbox = parentCheckboxList.find('.parent');
          var checkedSubOptions = parentCheckboxList.find('.child:checked');
          var subOptions = parentCheckboxList.find('.child');
          parentCheckbox.prop('indeterminate', checkedSubOptions.length && checkedSubOptions.length != subOptions.length);
        });
      }
    }
  }

  function sorting(e) {
    var usp = new URLSearchParams(window.location.search);
    var queryString = '?';
    if (usp.has('sort')) {
      usp.set('sort', $(this).val());
      queryString += usp.toString();
    } else {
      usp.append('sort', $(this).val());
      queryString += usp.toString();
    }

    submitAjax(e, queryString, '.sortering-dropdown dropdown-toggle', 'sort');
  }

  function setSortingButtonWidth() {
    $(sortDropdownKnapp).css('min-width', $(sortDropdownLista).outerWidth());
  }

  function accordionKnappResursbanken() {
    if ($('.HittaTipsSida, .HanteraTipsSida').length) {
      var knapp = $('.tipslista__kort-knapp button');
      knapp.each(function () {
        var btnText = $('.btn-text', this);
        $(this).click(function () {
          if ($(this).attr('aria-expanded') === 'false') {
            btnText.text('Visa mindre');
            $(this).attr('aria-label', 'Dölj längre beskrivning om tipset');
          } else {
            btnText.text('Visa mer');
            $(this).attr('aria-label', 'Visa längre beskrivning om tipset');
          }
        });
      });
    }
  }

  // 'Public'
  return {
    init: init,
  };
})(jQuery);

// Init when DOM is ready
jQuery(filterpanelblock.filters.init);
